import { IQuery } from '@captiveaire/query';

export class ModuleViewNavigationService {
    public static $name = 'moduleViewNavigationService';

    private errorMessage = `
        Client apps must provide their own ModuleViewNavigationService!
    `;

    public viewModule(moduleId: number, mac: string, locationId: number, query: IQuery) {
        throw new Error(this.errorMessage);
    }

    public viewHardwareItem(hardwareItemId: number, locationId: number, moduleId: number, mac: string, query: IQuery) {
        throw new Error(this.errorMessage);
    }
}
